import * as React from 'react';
import { Link } from 'react-router';
import { FlexRowCenterHorizontal, FlexRowCenterVertical } from 'eshop-defaults';
import styled from 'styled-components';

import { Loader } from 'eshop-defaults';

import Login from '../../containers/Auth/Login';
import Register from '../../containers/Auth/Register';
import { AuthTab } from '../../containers/Auth/Auth';
import { __ } from 'react-i18n';

import { ErrorAlert } from 'eshop-defaults';
import { AlertType } from 'eshop-defaults';
import { WarningAlert } from 'eshop-defaults';
import { SuccessAlert } from 'eshop-defaults';

import { Divider } from 'eshop-defaults';
import { MainContainer } from 'eshop-defaults';

import CategoryChain from '../Category/CategoryChain';
import { rem, rgba } from 'polished';

interface Props {
  tab: AuthTab;
  loading: boolean;
  alert:
    | {
        msg: string;
        type: AlertType;
      }
    | undefined;
  closeAlert: () => void;
  registerData: {
    email: string;
    pass: string;
    passAgain: string;
  };
  updateRegisterData: (data: object) => void;
  getLoginUrl: () => string;
  handleRegistration: (e) => Promise<void>;
  handleGoogle: () => void;
  handleFacebook: () => void;
}

export default class AuthComponent extends React.Component<Props, {}> {
  public render() {
    const {
      tab,
      loading,
      alert,
      registerData,
      updateRegisterData,
    } = this.props;

    const alertData = {
      show: false,
      msg: '',
      type: AlertType.Error,
    };
    if (alert) {
      alertData.show = true;
      alertData.msg = alert.msg;
      alertData.type = alert.type;
    }

    return (
      <>
        <MainContainer>
          <ChainWrapper>
            <CategoryChain
              categories={[
                { name: __('Môj účet'), url: __('routes:moj-ucet') },
              ]}
            />
          </ChainWrapper>
          <FlexRowCenterHorizontal>
            <AuthContainer>
              {alertData.show &&
                (alertData.type === AlertType.Error && (
                  <AlertBox>
                    <ErrorAlert
                      closeAlert={this.props.closeAlert}
                      message={alertData.msg}
                    />
                  </AlertBox>
                ))}
              {alertData.show &&
                (alertData.type === AlertType.Warning && (
                  <AlertBox>
                    <WarningAlert
                      closeAlert={this.props.closeAlert}
                      message={alertData.msg}
                    />
                  </AlertBox>
                ))}
              {alertData.show &&
                (alertData.type === AlertType.Success && (
                  <AlertBox>
                    <SuccessAlert
                      closeAlert={this.props.closeAlert}
                      message={alertData.msg}
                    />
                  </AlertBox>
                ))}
              <AuthWrapper>
                <Loader loading={loading}>
                  <React.Fragment>
                    <TabsHeaders>
                      <Link
                        to={__('routes:prihlasenie')}
                        style={{ width: '50%', textDecoration: 'none' }}
                      >
                        <TabHeader
                          className={
                            tab === AuthTab.Login ? 'left active' : 'left'
                          }
                        >
                          <span> {__('Prihlásenie')} </span>
                        </TabHeader>
                      </Link>

                      <Link
                        to={__('routes:registracia')}
                        style={{ width: '50%', textDecoration: 'none' }}
                      >
                        <TabHeader
                          className={
                            tab === AuthTab.Register ? 'right active' : 'right'
                          }
                        >
                          <span> {__('Registrácia')} </span>
                        </TabHeader>
                      </Link>
                    </TabsHeaders>
                  </React.Fragment>

                  <TabContent>
                    {tab === AuthTab.Login ? (
                      <Login
                        getLoginUrl={this.props.getLoginUrl}
                        handleFacebook={this.props.handleFacebook}
                        handleGoogle={this.props.handleGoogle}
                      />
                    ) : (
                      <Register
                        onRegDataChange={updateRegisterData}
                        regData={registerData}
                        handleRegister={this.props.handleRegistration}
                        handleFacebook={this.props.handleFacebook}
                        handleGoogle={this.props.handleGoogle}
                      />
                    )}
                  </TabContent>
                </Loader>
              </AuthWrapper>
            </AuthContainer>
          </FlexRowCenterHorizontal>
        </MainContainer>
        <Divider />
      </>
    );
  }
}

const AuthWrapper = styled.div`
  width: ${rem(350)};

  @media only screen and (max-width: 600px) {
    width: 100%;
    min-width: 0;
  }
`;

const AlertBox = styled.div`
  width: ${rem(350)};
  margin-bottom: ${rem(20)};

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

const TabContent = styled.div`
  width: 100%;
  border-left: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
  border-right: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
  border-bottom: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius || rem(4)};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius || rem(4)};
  border-collapse: collapse;
  padding: ${rem(30)};

  @media only screen and (max-width: 600px) {
    padding: ${rem(20)};
  }
`;

const TabsHeaders = styled(FlexRowCenterVertical)`
  .left {
    border-top-left-radius: ${({ theme }) => theme.borderRadius || rem(4)};
  }

  .right {
    border-top-right-radius: ${({ theme }) => theme.borderRadius || rem(4)};
  }

  .active {
    background: #ffffff;
    border-top: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
    border-left: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
    border-right: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
    border-bottom: none;
    border-collapse: collapse;
    padding: ${rem(19)};
    margin-top: ${rem(1)};

    & > span {
      color: ${({ theme }) => theme.primaryFontColor || theme.colors.primaryFontColor};
    }
  }
`;

const TabHeader = styled.div`
  width: 100%;
  padding: ${rem(20)};
  text-align: center;
  cursor: pointer;
  background: ${({ theme }) => `${rgba(theme.colors.secondary, 0.15)}` || `#f2fafa`};
  border-top-right-radius: ${({ theme }) => theme.borderRadius || rem(4)};
  border-bottom: ${rem(2)} solid ${({ theme }) => theme.colors.borderColor || `#eaeaea`};
  border-collapse: collapse;

  & > span {
    font-size: ${({ theme }) => theme.fontSizeS};
    font-family: ${({ theme }) => theme.primaryFont || theme.fonts.primaryFont};
    color: ${({ theme }) => theme.secondaryFontColor || theme.colors.secondaryFontColor};
  }
`;

export const AuthContainer = styled(FlexRowCenterHorizontal)`
  margin: ${rem(60)} 0;
  width: 100%;
  flex-direction: column;
  align-items: center;

  @media all and (max-width: 900px) {
    margin: ${rem(40)} 0;
  }
`;

const ChainWrapper = styled.div`
  margin-top: ${rem(30)};
`;
